import { Grid, GridProps } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import { CurrencyField, CurrencyFieldProps } from '../../../../atomic/input/currencyField';
import { FormFieldWrapper } from '../shared/formFieldWrapper';
import { FormFieldProps } from './index';

type FormCurrencyFieldProps = FormFieldProps &
  CurrencyFieldProps &
  Pick<GridProps, 'lg' | 'md' | 'sm' | 'xl' | 'xs'>;

export const FormCurrencyField = FormFieldWrapper<FormCurrencyFieldProps>(
  ({ additionalOnChange, ...rest }) => {
    const [field, meta] = useField<unknown>({
      name: rest.name
    });

    const { setFieldValue } = useFormikContext();

    const setValue = (value: number | string) => {
      setFieldValue(rest.name, value);
      additionalOnChange?.(value, setFieldValue);
    };

    return (
      <Grid item xs={rest.xs ?? 12} lg={rest.lg} md={rest.md} sm={rest.sm} xl={rest.xl}>
        <CurrencyField
          {...rest}
          placeholder={rest.placeholder ?? '0,00'}
          label={rest.label}
          type={rest.type}
          name={field.name}
          value={field.value ? field.value : undefined}
          onChange={(event) => setValue(event.target.value ?? '')}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          onBlur={field.onBlur}
        />
      </Grid>
    );
  }
);
